import TooltipHelper from "./TooltipHelper";
export interface ToolTipProps {
  id?: string;
  children?: any;
  required?: boolean;
  showLeft?: boolean;
  tooltipText?: any;
  backgroundColor?: string;
  className?: string;
}

const RequiredFieldTooltip = ({
  children,
  required,
  showLeft,
  tooltipText,
  id,
  backgroundColor,
  className,
}: ToolTipProps) => {
  const tooltipId = !!id
    ? id
    : showLeft === undefined
      ? "labelTooltip"
      : "labelLeftTip";

  const tooltipPlace = showLeft === undefined ? "top" : "left";
  return (
    <>
      <span
        data-tooltip-content={required ? tooltipText : undefined}
        data-tooltip-id={required ? tooltipId : undefined}
      >
        {children}
      </span>
      {required && (
        <TooltipHelper
          id={tooltipId}
          backgroundColor="#18B5B7"
          place={tooltipPlace}
          className={`text-xs p-2 max-w-[350px] bg-primary font-red backgroundColor-red z-[1000] ${className}`}
        />
      )}
    </>
  );
};

export default RequiredFieldTooltip;
